export default {
  insertWSData({ commit }, data) {
    commit(`insertWS${data.type}Messages`, data);
  }
};
